<script setup lang="ts">
import { useElementSize, useIntervalFn } from '@vueuse/core';
import { computed, ref, useTemplateRef, watch } from 'vue';

const { barWidth, barGap } = defineProps<{
	barWidth: number;
	barGap: number;
	barColor: string;
}>();

const svgRef = useTemplateRef('svg');
const { width, height } = useElementSize(svgRef);

const barRadius = computed(() => barWidth / 2);
const barCount = computed(() => width.value / (barWidth + barGap) + 1);
const bars = ref<number[]>([]);

watch(barCount, (newCount) => {
	bars.value = generateInitialWaveform(newCount);
});

useIntervalFn(() => {
	const newBars = [];

	for (let i = 0; i < barCount.value; i++) {
		const currentValue = bars.value[i] ?? 0;
		newBars.push(nextValue(currentValue));
	}

	bars.value = newBars;
}, 500);

function generateInitialWaveform(count: number) {
	const bars = [];
	let currentValue = Math.random();

	for (let i = 0; i < count; i++) {
		currentValue = nextValue(currentValue);
		bars.push(currentValue);
	}

	return bars;
}

function nextValue(current: number) {
	return Math.max(0.1, Math.min(current + (Math.random() * 0.2 - 0.1), 0.7));
}
</script>

<template>
	<svg ref="svg" class="absolute inset-0 size-full opacity-50" :style="{ color: barColor }">
		<rect
			v-for="(bar, index) in bars"
			:key="index"
			:rx="barRadius"
			:ry="barRadius"
			:x="index * (barWidth + barGap)"
			:y="(1 - bar) * height / 2"
			:width="barWidth"
			:height="bar * height"
			fill="currentColor"
			class="transition-all duration-500 ease-linear"
		/>
	</svg>
</template>
